import {SVGProps} from 'react';

import {COLORS} from '@/styles/colors';

export const PaletteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    width={props.width ?? 16}
    height={props.height ?? 17}
    viewBox="0 0 20 20"
    {...props}>
    <path
      fill={props.color ?? COLORS.ON_SURFACE_1}
      d="M7.999 15.646c-3.674 0-6.667-2.994-6.667-6.667 0-3.673 2.993-6.666 6.667-6.666 3.673 0 6.666 2.693 6.666 6 0 2.206-1.793 4-4 4h-1.18a.33.33 0 0 0-.333.333c0 .08.033.153.087.22.273.313.426.707.426 1.113 0 .92-.746 1.667-1.666 1.667Zm0-12a5.34 5.34 0 0 0-5.334 5.333A5.34 5.34 0 0 0 8 14.313a.33.33 0 0 0 .333-.334.36.36 0 0 0-.093-.233c-.274-.307-.42-.7-.42-1.1 0-.92.746-1.667 1.666-1.667h1.18a2.666 2.666 0 0 0 2.667-2.666c0-2.574-2.393-4.667-5.333-4.667Z"
    />
    <path
      fill={props.color ?? COLORS.ON_SURFACE_1}
      d="M4.332 9.646a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6.332 6.98a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM9.665 6.98a1 1 0 1 0 0-2.001 1 1 0 0 0 0 2ZM11.665 9.646a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
  </svg>
);
